export { default as SelectedLibraryItemsFloatingCounter } from './SelectedLibraryItemsFloatingCounter';
